import * as styled from 'styled-components'
import { Color } from './colors'

const noSelectStyling = styled.css`
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                supported by Chrome, Edge, Opera and Firefox */
`

export default styled.createGlobalStyle`
  * {
    ${noSelectStyling};
  }

  .noselectimg {
    pointer-events: none;
  }

  html,
  body,
  #root {
    margin: 0;
    padding: 0;

    background-color: ${Color.PRIMARY};

    width: 100%;
    height: 100%;

    font-family: Arial, Helvetica, Arial, sans-serif;
  }

  .tp-dfwv {
    z-index: 999;

    height: auto;

    left: 0;
    top: 0 !important;
  }
`
